<i18n>
{
  "fr": {
    "configuratorCustomThemeList": {
    }
  }
}
</i18n>

<template>
  <div class="configurator-custom-theme-list">
    <div class="configurator-custom-theme-list__group">
      <ConfiguratorProductList
        :is-docked="isDocked"
        :items="[...cmykProducts, ...screenPrintingProducts]"
        @request-open-theme-picker-modal="
          $emit('request-open-theme-picker-modal')
        "
      />
    </div>
  </div>
</template>

<script>
import ConfiguratorProductList from './ConfiguratorProductList';
import {
  GlassesGetter,
  prefixType as prefixGlassesType,
} from '../../store/modules/configurator/glasses';
import { CMYK_ORDER, SCREEN_PRINTING_ORDER } from '../../utils/Variables';

export default {
  name: 'ConfiguratorCustomThemeList',
  emits: ['request-open-theme-picker-modal'],
  components: { ConfiguratorProductList },
  props: {
    isDocked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * @returns {Array}
     */
    cmykProductsOrder() {
      return this.parseProductOrder(CMYK_ORDER);
    },
    /**
     * @returns {Array}
     */
    cmykProducts() {
      return [
        ...this.$store.getters[
          prefixGlassesType(GlassesGetter.GET_CUSTOM_CMYK_THEMES)
        ],
      ].sort(
        (first, second) =>
          this.cmykProductsOrder.indexOf(first.product.id) -
          this.cmykProductsOrder.indexOf(second.product.id)
      );
    },
    /**
     * @returns {Array}
     */
    screenPrintingProductsOrder() {
      return this.parseProductOrder(SCREEN_PRINTING_ORDER);
    },
    /**
     * @returns {Array}
     */
    screenPrintingProducts() {
      return [
        ...this.$store.getters[
          prefixGlassesType(GlassesGetter.GET_CUSTOM_SCREEN_PRINTING_THEMES)
        ],
      ].sort(
        (first, second) =>
          this.screenPrintingProductsOrder.indexOf(first.product.id) -
          this.screenPrintingProductsOrder.indexOf(second.product.id)
      );
    },
  },
  methods: {
    parseProductOrder(value) {
      if (!value) {
        return [];
      }

      try {
        const data = JSON.parse(value);
        return Array.isArray(data) ? data : [];
      } catch (e) {
        console.error(e);
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-custom-theme-list {
  $block-selector: &;

  &__group-heading {
    display: flex;
    margin-bottom: 0.5em;
    align-items: center;

    &::before {
      margin-right: 0.5em;
      flex: none;
      display: block;
      width: 15px;
      height: 20px;
      content: '';
      background-size: contain;
    }
  }
}
</style>
